import { connect } from "react-redux";
//
import { getGenderName } from "../utils";
import {
  getCity,
  getModelsOnline,
  getModelsFavorite,
  getActiveFilterValues,
} from "../selectors";
import ModelListScreen from "../components/ModelListScreen";

// @connect
import { setModelsVisibleAction } from "../modules/models/actions";

const props = (state) => {
  const { auth, booking, modal, models } = state;

  const modelsOnline = getModelsOnline(state);
  const modelsFavorite = getModelsFavorite(state);
  const filters = getActiveFilterValues(state);
  const city = getCity(state);

  let premiumAlert = null;

  if (!auth.isPremium) {
    premiumAlert =
      "Marking companions as favorite is only available for _Premium members_.";
  }

  return {
    city,
    isActive: modal.screen === "models",
    genderName: getGenderName(booking.genderId),
    models: modelsFavorite,
    modelsCount: modelsOnline.length,
    filtersCount: filters.length,
    user: auth.user,
    infoText: modelsFavorite.length ? null : "Your favorite list is empty",
    infoIcon: "favorite",
    selectedTab: models.visible,
    premiumAlert,
  };
};

const actions = {
  setModelsVisible: setModelsVisibleAction,
};

export default connect(
  props,
  actions
)(ModelListScreen);
